import { useEffect, useState } from "react";
import { API_URL } from "../App"; 
import "./MovieModal.css";

const MovieModal = ({ movie, onClose }) => {
  const [details, setDetails] = useState(null);
  const API_URL = "https://www.omdbapi.com/?apikey=9a93a967";

  useEffect(() => {
    const fetchDetails = async () => {
      const response = await fetch(`${API_URL}&i=${movie.imdbID}&plot=full`);
      const data = await response.json();
      setDetails(data);
    };
    fetchDetails();
  }, [movie]);

  if (!details) return null;

  return (
     <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✖</button>
        <div className="modal-header">
          <img
            src={details.Poster !== "N/A" ? details.Poster : "https://via.placeholder.com/400"}
            alt={details.Title}
          />
          <div className="modal-info">
            <h2>{details.Title} ({details.Year})</h2>
            <p><b>Type:</b> {details.Type}</p>
            <p><b>Genre:</b> {details.Genre}</p>
            <p><b>Director:</b> {details.Director}</p>
            <p><b>Actors:</b> {details.Actors}</p>
            <p><b>IMDb Rating:</b> ⭐ {details.imdbRating}</p>
          </div>
        </div>
        <p className="plot">{details.Plot}</p>
      </div>
    </div>
  );
};

export default MovieModal;
